/**
 * 资产
 * @type {{token: *, username: *, nickName: *, userId: string, avatar: *}}
 */
const state = {
  page: 1,
  original_type_condi: "0",
  guarante_des: "",
  pm_object_type: "",
  in_pm_object_type: "",
  create_startdate: "",
  create_enddate: "",
  abstract: "",
  pm_address_1: "",
  pm_address_2: "",
  pm_address_3: ""
};

const getters = {
  getPage: state => state.page,
  getGuaranteDes: state => state.guarante_des,
  getOriginalTypeCondi: state => state.original_type_condi,
  getPmObjectType: state => state.pm_object_type,
  getInPmObjectType: state => state.in_pm_object_type,
  getCreateStartdate: state => state.create_startdate,
  getCreateEnddate: state => state.create_enddate,
  getAbstract: state => state.abstract,
  getPmAddress1: state => state.pm_address_1,
  getPmAddress2: state => state.pm_address_2,
  getPmAddress3: state => state.pm_address_3
};

const action = {};

const mutations = {
  setPage(state, page) {
    state.page = page;
  },
  setOriginalTypeCondi(state, original_type_condi) {
    state.original_type_condi = original_type_condi;
  },
  setGuaranteDes(state, guarante_des) {
    state.guarante_des = guarante_des;
  },
  setPmObjectType(state, pm_object_type) {
    state.pm_object_type = pm_object_type;
  },
  setInPmObjectType(state, in_pm_object_type) {
    state.in_pm_object_type = in_pm_object_type;
  },
  setCreateStartdate(state, create_startdate) {
    state.create_startdate = create_startdate;
  },
  setCreateEnddate(state, create_enddate) {
    state.create_enddate = create_enddate;
  },
  setAbstract(state, abstract) {
    state.abstract = abstract;
  },
  setPmAddress1(state, pm_address_1) {
    state.pm_address_1 = pm_address_1;
  },
  setPmAddress2(state, pm_address_2) {
    state.pm_address_2 = pm_address_2;
  },
  setPmAddress3(state, pm_address_3) {
    state.pm_address_3 = pm_address_3;
  }
};

export default {
  state,
  getters,
  action,
  mutations
};
